/* eslint-disable max-len */

import { Box } from '@mui/material';

/**
 * Иконка загрузкии
 */
export const TrobberIcon = () => {
  /**
   * рендер освноного компонента
   */
  const renderContent = () => (
    <Box sx={{
      animation: 'spin 3s linear infinite',
      '@keyframes spin': {
        '0%': { transform: 'rotate(360deg)' },
        '100%': { transform: 'rotate(0deg)' }
      }
    }}>
      <svg width='90' height='90' viewBox='0 0 90 90' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path fillRule='evenodd' clipRule='evenodd' d='M7.59361 57.0944L12.9374 55.4069C11.8085 52.054 11.2384 48.5384 11.2499 45.0006H5.62486C5.56871 49.116 6.23506 53.2093 7.59361 57.0944ZM21.9374 76.7819C18.632 74.4134 15.6941 71.5703 13.2186 68.3444L17.7186 64.9694C19.8908 67.7542 22.4476 70.2163 25.3124 72.2819L21.9374 76.7819ZM32.9061 82.4069L34.5936 77.0631C37.9465 78.1919 41.4621 78.762 44.9999 78.7506V84.3756C40.8845 84.4318 36.7912 83.7654 32.9061 82.4069ZM57.3749 82.4069C61.2967 81.1026 64.9958 79.2056 68.3436 76.7819L64.9686 72.2819C62.1217 74.3151 58.9956 75.9255 55.6874 77.0631L57.3749 82.4069ZM76.7811 68.0631C79.2048 64.7153 81.1018 61.0162 82.4061 57.0944L77.0624 55.4069C75.9248 58.7151 74.3143 61.8413 72.2811 64.6881L76.7811 68.0631ZM68.0624 13.2194C71.3752 15.6884 74.312 18.6253 76.7811 21.9381L72.2811 25.3131C70.1895 22.3774 67.6231 19.811 64.6874 17.7194L68.0624 13.2194ZM55.4061 12.9381L57.0936 7.59438C53.1754 6.37094 49.1038 5.70812 44.9999 5.62563V11.2506C48.5376 11.2392 52.0532 11.8093 55.4061 12.9381ZM21.6561 13.5006C25.0039 11.0769 28.703 9.17996 32.6249 7.87563L34.3124 13.2194C31.0041 14.357 27.878 15.9674 25.0311 18.0006L21.6561 13.5006ZM12.9374 22.2194C10.5137 25.5672 8.61669 29.2663 7.31236 33.1881L12.6561 34.8756C13.7937 31.5674 15.4041 28.4412 17.4374 25.5944L12.9374 22.2194ZM77.0624 34.5944L82.4061 32.9069C83.4717 36.8607 84.1313 40.9129 84.3749 45.0006H78.7499C78.7613 41.4629 78.1912 37.9473 77.0624 34.5944Z' fill='url(#paint0_linear_3650_25502)' />
        <defs>
          <linearGradient id='paint0_linear_3650_25502' x1='5.62158' y1='5.62564' x2='97.0141' y2='25.1178' gradientUnits='userSpaceOnUse'>
            <stop stopColor='#FBFBFF' />
            <stop offset='1' stopColor='#7172F1' />
          </linearGradient>
        </defs>
      </svg>
    </Box>
  );

  return renderContent();
};
